import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCamera = () => {
  return (
    <g>
      <path d="M10.246 1c.474 0 .883.316 1.01.763l.026.114.354 2.122L15 4a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1l3.364-.001.354-2.122a1.05 1.05 0 0 1 .92-.87L5.753 1h4.492zM14.5 5.5h-13v8h13v-8zM8 6.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM8 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm1.865-5.5H6.134L5.885 4h4.229l-.249-1.5z" />
    </g>
  );
};

export default withIcon(IconCamera);
